export const getParamsWithPrefix = (prefix: string): Record<string, string> => {
    const filteredParams = {};
    const allParams = getUrlParams();

    for (const key of Object.keys(allParams)) {
        if (key.startsWith(prefix)) {
            const paramKey = key.substring(prefix.length);
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- Automatically disabled using eslint-interactive
            // @ts-ignore TS7053
            filteredParams[paramKey] = allParams[key];
        }
    }

    return filteredParams;
};

export const getUrlParams = () => {
    const params: Record<string, string | undefined> = {};
    const url = new URL(window.location.href);
    for (const key of url.searchParams.keys()) {
        const value = url.searchParams.get(key);
        if (value) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- Automatically disabled using eslint-interactive
            // @ts-ignore TS7053
            params[key] = value.trim();
        }
    }
    return params;
};

const getRecordIdFromPath = (): string | undefined => {
    const matches = window.location.pathname.match(/\/r\/([^/]+)\/?/);
    if (matches && matches[1]) {
        return matches[1];
    }

    return undefined;
};

export const getUrlRecordId = (): string | undefined => {
    const params = getUrlParams();
    const recordIdKey = Object.keys(params).find((key) => key.toLowerCase() === "recordid");

    return recordIdKey ? params[recordIdKey] : getRecordIdFromPath();
};

export const getCurrentPath = () => {
    let pagePath = window.location.pathname;

    if (pagePath.includes("/r/")) {
        pagePath = pagePath.substring(0, pagePath.indexOf("/r/"));
        pagePath = pagePath.substring(0, pagePath.lastIndexOf("/"));
    }

    return pagePath + (pagePath.endsWith("/") ? "" : "/");
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Automatically disabled using eslint-interactive
export const linkifyWithParams = (url: string | string[], urlParams?: Record<string, any>): string => {
    if (!url || !url.length) {
        return "#";
    }

    if (Array.isArray(url)) {
        url = url[0];
    }

    if (url.startsWith("mailto") || url.startsWith("tel") || url.startsWith("sms")) {
        return url;
    }

    let link = "";

    if (url.startsWith("http") || url.startsWith("#") || url.startsWith("/")) {
        link = url;
    } else if (url.indexOf(".") !== -1) {
        link = "https://" + url;
    }

    const currentPath = getCurrentPath();
    if (link && link.startsWith(currentPath + "#")) {
        link = "#" + link.split("#")[1];
    }

    if (urlParams && !link.startsWith("#")) {
        try {
            const validUrl = new URL(link, `${window.location.origin}/${window.location.pathname}`);
            Object.entries(urlParams).forEach(([name, value]) => {
                validUrl.searchParams.append(name, value);
            });
            return validUrl.href;
        } catch (e) {
            console.error(`Can't add url params to '${link}' url.`, e);
        }
    }

    return link;
};

export const getUrlExtension = (url: string) => {
    const ext = url.split("?")[0]?.split(".");
    return ext[ext.length - 1]?.toLowerCase();
};

export const isUrlLocal = (url: string) => {
    return url.startsWith("#") || url.startsWith("/") || url.startsWith(window.location.origin);
};

const IS_IN_MODAL = window.location.href.includes("viewMode=modal");
export const isInModal = () => {
    // It's important that IS_IN_MODAL is evaluated once at module load time
    // because we never want this value to change during the lifecycle of the app.
    // For example, in case a link within the modal changes the URL of the iframe
    // and forgets to preserve the viewMode=modal parameter, we don't want a nested
    // modal to show up.
    return IS_IN_MODAL;
};

